import { tourFactory, getTourStepButtons } from './tourUtils';

const dashboardTour = tourFactory('dashboard');

dashboardTour.addStep({
  text: `
        Aqui você terá informações sobre os valores gerados e agendados para pagamento.
        `,
  attachTo: {
    element: '#paymentInformationDash',
    on: 'bottom',
  },
  scrollToHandler() {
    window.scroll(0, 150);
  },
  buttons: getTourStepButtons(dashboardTour, true),
});

dashboardTour.addStep({
  text: 'Tenha informações rápidas sobre o desempenho de seus anunciantes em impressões, cliques e ganhos',
  attachTo: {
    element: '#consolidateChart',
    on: 'top',
  },
  scrollToHandler() {
    window.scroll(0, 270);
  },
  buttons: getTourStepButtons(dashboardTour),
});

dashboardTour.addStep({
  text: 'Acompanhe o número total das campanhas que está veiculando nos últimos 30 dias.',
  attachTo: {
    element: '#performanceGraph',
    on: 'left',
  },
  scrollToHandler() {
    window.scroll(0, 800);
  },
  buttons: getTourStepButtons(dashboardTour),
});

/* LinkFormCard */
dashboardTour.addStep({
  text: 'Gere o link rapidamente para divulgar suas campanhas.',
  attachTo: {
    element: '#LinkFormCard',
    on: 'bottom',
  },
  buttons: getTourStepButtons(dashboardTour),
});

dashboardTour.addStep({
  text: 'Então vamos começar!<br /> Clique em <strong>Campanhas</strong>',
  attachTo: {
    element: '.menu-inferior li:nth-child(3)',
    on: 'bottom',
  },
  buttons: getTourStepButtons(dashboardTour, false, true),
  advanceOn: { selector: '.menu-inferior li:nth-child(3)', event: 'click' },
});

export default dashboardTour;
